import { LoginType } from '~/interfaces';

export const ACCOUNT_LOGIN = [LoginType.Account, LoginType.AccountPassword, LoginType.PhoneCode];

export const CORP_ACCOUNT_LOGIN = [
    LoginType.Account,
    LoginType.AccountPassword,
    LoginType.PhoneCode,
    LoginType.Wxwork,
    LoginType.Lark,
    LoginType.Dingtalk
];

/** 无 Suite 上下文时，可以从缓存直接恢复的登录方式。 */
export const LOGIN_TYPES_WITHOUT_SUITE_ID = [LoginType.Account, LoginType.Wechat, LoginType.Tenant];
/** 普通登录页允许缓存的登录方式 */
export const NORMAL_LOGIN_ALLOW_CACHE_TYPES = [
    LoginType.Account,
    LoginType.Wechat,
    LoginType.Tenant,
    LoginType.Wxwork
];
